import React from 'react'
import PropTypes from 'prop-types';
import { Link, navigate } from 'gatsby'
import { linkBtnPrev, linkBtn } from './sequenceButton.module.scss'


function SequenceButton({ 
    path, 
    text, 
    previous = false
 }){
    return (
        <button type="button" onClick={() => navigate(path)} className={previous ? linkBtnPrev : linkBtn}>
            <Link to={path}>
                {text} 
            </Link>
        </button>
    )
}

SequenceButton.propTypes = {
    path: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    previous: PropTypes.bool,
}

export default SequenceButton